var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-inline d-inline"},_vm._l((_vm.rolesToShow),function(role,index){return _c('b-badge',{key:`role_${index}`,staticClass:"mr-1 text-with",attrs:{"variant":"success"}},[_vm._v(" "+_vm._s(role)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }